import { defineMessages } from "./define.js";

/** The shell: the four tabs, the header, the things always on screen. */
export const layout = defineMessages("layout", {
  sections: { ru: "Разделы", en: "Sections" },
  lists: { ru: "Списки", en: "Lists" },
  calendar: { ru: "Календарь", en: "Calendar" },
  chat: { ru: "Чат", en: "Chat" },
  wishes: { ru: "Хотелки", en: "Wishes" },
  map: { ru: "Места", en: "Places" },
  search: { ru: "Поиск", en: "Search" },
  activity: { ru: "Что изменилось", en: "What changed" },
  settings: { ru: "Настройки", en: "Settings" },
  notFound: { ru: "Такой страницы нет", en: "No such page" },
  backToLists: { ru: "Вернуться к спискам", en: "Back to lists" },
});
